import { FC } from 'react';
import { RulesRecords } from '../../_types/productItem.types';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import Icon from '@/components/UI/icon/Icon';
import styles from './PeopleCount.module.scss';
type PeopleCountProps = {
  guests: number;
  setGuests: (guest: number) => void;
  maxAccommodates: number;
  blink: boolean;
  rules: RulesRecords;
};
const PeopleCount: FC<PeopleCountProps> = ({
  guests,
  setGuests,
  maxAccommodates,
  blink,
  rules
}) => {
  const extra = rules?.max_accommodates - rules?.accommodates;
  const handleIncrement = () => {
    const incrementedValue = isNaN(+guests) ? 1 : +guests + 1;
    if (maxAccommodates && incrementedValue > maxAccommodates) {
      setGuests(maxAccommodates);
    } else {
      setGuests(incrementedValue);
    }
  };
  const handleDecrement = () => {
    const decrementedValue = +guests > 1 ? +guests - 1 : 1 || '';
    setGuests(decrementedValue);
  };
  return <Box className={`${styles['people-count']} ${blink ? styles['blink'] : ''}`} data-sentry-element="Box" data-sentry-component="PeopleCount" data-sentry-source-file="PeopleCount.tsx">
      <Box className={`${styles['add-icon']} ${+guests >= Number(maxAccommodates) ? styles['disable-icon'] : ''}`} onClick={handleIncrement} data-sentry-element="Box" data-sentry-source-file="PeopleCount.tsx">
        <Icon name="add" size={'xLarge'} type={+guests >= Number(maxAccommodates) ? 'lowEmphasis' : 'primary'} data-sentry-element="Icon" data-sentry-source-file="PeopleCount.tsx" />
      </Box>

      <Box className={styles['main-section']} data-sentry-element="Box" data-sentry-source-file="PeopleCount.tsx">
        {guests ? <Typography variant="bodyM">
            {`${guests < rules?.accommodates ? guests : rules?.accommodates} نفر  ${Boolean(extra) && guests - rules?.accommodates > 0 ? `پایه + ${guests - rules?.accommodates}
                      نفر اضافه ` : ''}`}
          </Typography> : <Box className="placeholder">0 نفر</Box>}
      </Box>

      <Box onClick={handleDecrement} className={`${styles['add-icon']} ${+guests <= 1 ? styles['disable-icon'] : ''}`} data-sentry-element="Box" data-sentry-source-file="PeopleCount.tsx">
        <Icon name="minus" size={'xLarge'} type={+guests <= 1 ? 'lowEmphasis' : 'primary'} data-sentry-element="Icon" data-sentry-source-file="PeopleCount.tsx" />
      </Box>
    </Box>;
};
export default PeopleCount;